export function coordinationCalculation(collection) {
  if (!!collection?.lnegth) return []
  let fontSizePhen = 16
  let fontSizePhenIcon = 24
  let fontSizePhenIcon2 = 32
  if (document.body.clientWidth <= 800) {
    fontSizePhenIcon = 15
    fontSizePhenIcon2 = 24
  } else if (document.body.clientWidth <= 400) {
    fontSizePhenIcon = 8
    fontSizePhenIcon2 = 16
  }
  collection?.forEach((completedPhenomenon) => {
    const thisYear = new Date().getFullYear()
    let mediumTimeRange = !!completedPhenomenon?.content?.time_range?.max
      ? (completedPhenomenon?.content?.time_range?.max +
          completedPhenomenon?.content?.time_range?.min) /
        2
      : completedPhenomenon?.crowdsourced
    if (Number(mediumTimeRange) < Number(thisYear)) {
      mediumTimeRange = thisYear
    }
    const howmuchBetweenYears1 = 2040 - thisYear
    const howmuchBetweenYearsOfPhen1 = 2040 - mediumTimeRange
    const range1 = (howmuchBetweenYearsOfPhen1 * 100) / howmuchBetweenYears1
    const extraFontSize = range1 / 30
    let top = 0

    if (!!completedPhenomenon) {
      // no phen has same time-range year
      if (!completedPhenomenon?.length || completedPhenomenon?.length === 1) {
        const min = 40
        const max = 60
        const randomNumber = Math.random() * (max - min + 1) + min
        completedPhenomenon['leftPostion1st'] = randomNumber + '%'
      } else if (!!completedPhenomenon['over_2040']) {
        if (completedPhenomenon['length'] === 2) {
          if (completedPhenomenon['position_over_2040'] === 1) {
            completedPhenomenon['leftPostion1st'] = '35%'
          } else if (completedPhenomenon['position_over_2040'] === 2) {
            completedPhenomenon['leftPostion1st'] = '85%'
          }
        } else if (completedPhenomenon['length'] === 3) {
          if (completedPhenomenon['position_over_2040'] === 1) {
            const min = 45
            const max = 55
            const randomNumber = Math.random() * (max - min + 1) + min
            completedPhenomenon['leftPostion1st'] = randomNumber + '%'
            //  '50%'
          } else if (completedPhenomenon['position_over_2040'] === 2) {
            const min = 10
            const max = 90
            const randomNumber = Math.random() * (max - min + 1) + min
            completedPhenomenon['leftPostion1st'] = randomNumber + '%'
            //  '25.5%'
          } else if (completedPhenomenon['position_over_2040'] === 3) {
            const min = 55
            const max = 95
            const randomNumber = Math.random() * (max - min + 1) + min
            completedPhenomenon['leftPostion1st'] = randomNumber + '%'
            //  '75.5%'
          }
        } else if (completedPhenomenon['length'] === 4) {
          if (completedPhenomenon['position_over_2040'] === 1) {
            const min = 40
            const max = 60
            const randomNumber = Math.random() * (max - min + 1) + min
            completedPhenomenon['leftPostion1st'] = randomNumber + '%'
            //  '40.5%'
          } else if (completedPhenomenon['position_over_2040'] === 2) {
            const min = 5
            const max = 40
            const randomNumber = Math.random() * (max - min + 1) + min
            completedPhenomenon['leftPostion1st'] = randomNumber + '%'
            //  '60.5%'
          } else if (completedPhenomenon['position_over_2040'] === 3) {
            const min = 60
            const max = 99
            const randomNumber = Math.random() * (max - min + 1) + min
            completedPhenomenon['leftPostion1st'] = randomNumber + '%'
            //  '15.5%'
          }
        } else if (completedPhenomenon['length'] === 5) {
          if (completedPhenomenon['position_over_2040'] === 1) {
            const min = 45
            const max = 55
            const randomNumber = Math.random() * (max - min + 1) + min
            completedPhenomenon['leftPostion1st'] = randomNumber + '%'
            //  completedPhenomenon['leftPostion1st'] = '50%'
          } else if (completedPhenomenon['position_over_2040'] === 2) {
            const min = 30
            const max = 40
            const randomNumber = Math.random() * (max - min + 1) + min
            completedPhenomenon['leftPostion1st'] = randomNumber + '%'
            completedPhenomenon['leftPostion1st'] = '35.2%'
          } else if (completedPhenomenon['position_over_2040'] === 3) {
            const min = 60
            const max = 80
            const randomNumber = Math.random() * (max - min + 1) + min
            completedPhenomenon['leftPostion1st'] = randomNumber + '%'
            completedPhenomenon['leftPostion1st'] = '75.2%'
          } else if (completedPhenomenon['position_over_2040'] === 4) {
            const min = 1
            const max = 15
            const randomNumber = Math.random() * (max - min + 1) + min
            completedPhenomenon['leftPostion1st'] = randomNumber + '%'
            completedPhenomenon['leftPostion1st'] = '10.2%'
          } else if (completedPhenomenon['position_over_2040'] === 5) {
            const min = 80
            const max = 99
            const randomNumber = Math.random() * (max - min + 1) + min
            completedPhenomenon['leftPostion1st'] = randomNumber + '%'
            completedPhenomenon['leftPostion1st'] = '90.2%'
          }
        } else if (completedPhenomenon['length'] === 6) {
          if (completedPhenomenon['position_over_2040'] === 1) {
            const min = 40
            const max = 60
            const randomNumber = Math.random() * (max - min + 1) + min
            completedPhenomenon['leftPostion1st'] = randomNumber + '%'
            completedPhenomenon['leftPostion1st'] = '60.8%'
          } else if (completedPhenomenon['position_over_2040'] === 2) {
            const min = 30
            const max = 45
            const randomNumber = Math.random() * (max - min + 1) + min
            completedPhenomenon['leftPostion1st'] = randomNumber + '%'
            completedPhenomenon['leftPostion1st'] = '40.8%'
          } else if (completedPhenomenon['position_over_2040'] === 3) {
            const min = 20
            const max = 35
            const randomNumber = Math.random() * (max - min + 1) + min
            completedPhenomenon['leftPostion1st'] = randomNumber + '%'
            completedPhenomenon['leftPostion1st'] = '30.8%'
          } else if (completedPhenomenon['position_over_2040'] === 4) {
            const min = 60
            const max = 70
            const randomNumber = Math.random() * (max - min + 1) + min
            completedPhenomenon['leftPostion1st'] = randomNumber + '%'
            completedPhenomenon['leftPostion1st'] = '70.8%'
          } else if (completedPhenomenon['position_over_2040'] === 5) {
            const min = 15
            const max = 20
            const randomNumber = Math.random() * (max - min + 1) + min
            completedPhenomenon['leftPostion1st'] = randomNumber + '%'
            completedPhenomenon['leftPostion1st'] = '20.8%'
          } else if (completedPhenomenon['position_over_2040'] === 6) {
            const min = 85
            const max = 99
            const randomNumber = Math.random() * (max - min + 1) + min
            completedPhenomenon['leftPostion1st'] = randomNumber + '%'
            completedPhenomenon['leftPostion1st'] = '80.8%'
          }
        } else if (completedPhenomenon['length'] === 7) {
          if (completedPhenomenon['position_over_2040'] === 1) {
            const min = 45
            const max = 55
            const randomNumber = Math.random() * (max - min + 1) + min
            completedPhenomenon['leftPostion1st'] = randomNumber + '%'
            //  completedPhenomenon['leftPostion1st'] = '50%'
          } else if (completedPhenomenon['position_over_2040'] === 2) {
            const min = 40
            const max = 55
            const randomNumber = Math.random() * (max - min + 1) + min
            completedPhenomenon['leftPostion1st'] = randomNumber + '%'
            completedPhenomenon['leftPostion1st'] = '40.4%'
          } else if (completedPhenomenon['position_over_2040'] === 3) {
            const min = 60
            const max = 70
            const randomNumber = Math.random() * (max - min + 1) + min
            completedPhenomenon['leftPostion1st'] = randomNumber + '%'
            completedPhenomenon['leftPostion1st'] = '60.4%'
          } else if (completedPhenomenon['position_over_2040'] === 4) {
            const min = 35
            const max = 40
            const randomNumber = Math.random() * (max - min + 1) + min
            completedPhenomenon['leftPostion1st'] = randomNumber + '%'
            completedPhenomenon['leftPostion1st'] = '30.4%'
          } else if (completedPhenomenon['position_over_2040'] === 5) {
            const min = 65
            const max = 75
            const randomNumber = Math.random() * (max - min + 1) + min
            completedPhenomenon['leftPostion1st'] = randomNumber + '%'
            completedPhenomenon['leftPostion1st'] = '70.4%'
          } else if (completedPhenomenon['position_over_2040'] === 6) {
            const min = 16
            const max = 20
            const randomNumber = Math.random() * (max - min + 1) + min
            completedPhenomenon['leftPostion1st'] = randomNumber + '%'
            completedPhenomenon['leftPostion1st'] = '20.4%'
          } else if (completedPhenomenon['position_over_2040'] === 7) {
            const min = 75
            const max = 80
            const randomNumber = Math.random() * (max - min + 1) + min
            completedPhenomenon['leftPostion1st'] = randomNumber + '%'
            completedPhenomenon['leftPostion1st'] = '80.4%'
          }
        } else if (completedPhenomenon['length'] === 8) {
          if (completedPhenomenon['position_over_2040'] === 1) {
            completedPhenomenon['leftPostion1st'] = '60.6%'
          } else if (completedPhenomenon['position_over_2040'] === 2) {
            completedPhenomenon['leftPostion1st'] = '40.6%'
          } else if (completedPhenomenon['position_over_2040'] === 3) {
            completedPhenomenon['leftPostion1st'] = '30.6%'
          } else if (completedPhenomenon['position_over_2040'] === 4) {
            completedPhenomenon['leftPostion1st'] = '70.6%'
          } else if (completedPhenomenon['position_over_2040'] === 5) {
            completedPhenomenon['leftPostion1st'] = '20.6%'
          } else if (completedPhenomenon['position_over_2040'] === 6) {
            completedPhenomenon['leftPostion1st'] = '80.6%'
          } else if (completedPhenomenon['position_over_2040'] === 7) {
            completedPhenomenon['leftPostion1st'] = '10.6%'
          } else if (completedPhenomenon['position_over_2040'] === 8) {
            completedPhenomenon['leftPostion1st'] = '90.6%'
          }
        } else if (completedPhenomenon['length'] === 9) {
          if (completedPhenomenon['position_over_2040'] === 1) {
            const min = 45
            const max = 55
            const randomNumber = Math.random() * (max - min + 1) + min
            completedPhenomenon['leftPostion1st'] = randomNumber + '%'
            //  completedPhenomenon['leftPostion1st'] = '50%'
          } else if (completedPhenomenon['position_over_2040'] === 2) {
            completedPhenomenon['leftPostion1st'] = '40.3%'
          } else if (completedPhenomenon['position_over_2040'] === 3) {
            completedPhenomenon['leftPostion1st'] = '60.3%'
          } else if (completedPhenomenon['position_over_2040'] === 4) {
            completedPhenomenon['leftPostion1st'] = '30.3%'
          } else if (completedPhenomenon['position_over_2040'] === 5) {
            completedPhenomenon['leftPostion1st'] = '70.3%'
          } else if (completedPhenomenon['position_over_2040'] === 6) {
            completedPhenomenon['leftPostion1st'] = '20.3%'
          } else if (completedPhenomenon['position_over_2040'] === 7) {
            completedPhenomenon['leftPostion1st'] = '80.3%'
          } else if (completedPhenomenon['position_over_2040'] === 8) {
            completedPhenomenon['leftPostion1st'] = '10.3%'
          } else if (completedPhenomenon['position_over_2040'] === 9) {
            completedPhenomenon['leftPostion1st'] = '90.3%'
          }
        } else if (completedPhenomenon['length'] === 10) {
          if (completedPhenomenon['position_over_2040'] === 1) {
            completedPhenomenon['leftPostion1st'] = '58%'
          } else if (completedPhenomenon['position_over_2040'] === 2) {
            completedPhenomenon['leftPostion1st'] = '42%'
          } else if (completedPhenomenon['position_over_2040'] === 3) {
            completedPhenomenon['leftPostion1st'] = '28%'
          } else if (completedPhenomenon['position_over_2040'] === 4) {
            completedPhenomenon['leftPostion1st'] = '73%'
          } else if (completedPhenomenon['position_over_2040'] === 5) {
            completedPhenomenon['leftPostion1st'] = '22%'
          } else if (completedPhenomenon['position_over_2040'] === 6) {
            completedPhenomenon['leftPostion1st'] = '79%'
          } else if (completedPhenomenon['position_over_2040'] === 7) {
            completedPhenomenon['leftPostion1st'] = '10%'
          } else if (completedPhenomenon['position_over_2040'] === 8) {
            completedPhenomenon['leftPostion1st'] = '92%'
          } else if (completedPhenomenon['position_over_2040'] === 9) {
            completedPhenomenon['leftPostion1st'] = '5.5%'
          } else if (completedPhenomenon['position_over_2040'] === 10) {
            completedPhenomenon['leftPostion1st'] = '98.3%'
          }
        } else if (completedPhenomenon['length'] === 11) {
          if (completedPhenomenon['position_over_2040'] === 1) {
            const min = 45
            const max = 55
            const randomNumber = Math.random() * (max - min + 1) + min
            completedPhenomenon['leftPostion1st'] = randomNumber + '%'
            //  completedPhenomenon['leftPostion1st'] = '50%'
          } else if (completedPhenomenon['position_over_2040'] === 2) {
            completedPhenomenon['leftPostion1st'] = '43%'
          } else if (completedPhenomenon['position_over_2040'] === 3) {
            completedPhenomenon['leftPostion1st'] = '63%'
          } else if (completedPhenomenon['position_over_2040'] === 4) {
            completedPhenomenon['leftPostion1st'] = '33%'
          } else if (completedPhenomenon['position_over_2040'] === 5) {
            completedPhenomenon['leftPostion1st'] = '73%'
          } else if (completedPhenomenon['position_over_2040'] === 6) {
            completedPhenomenon['leftPostion1st'] = '23%'
          } else if (completedPhenomenon['position_over_2040'] === 7) {
            completedPhenomenon['leftPostion1st'] = '83%'
          } else if (completedPhenomenon['position_over_2040'] === 8) {
            completedPhenomenon['leftPostion1st'] = '13%'
          } else if (completedPhenomenon['position_over_2040'] === 9) {
            completedPhenomenon['leftPostion1st'] = '93%'
          } else if (completedPhenomenon['position_over_2040'] === 10) {
            completedPhenomenon['leftPostion1st'] = '96.6%'
          } else if (completedPhenomenon['position_over_2040'] === 11) {
            completedPhenomenon['leftPostion1st'] = '4.3%'
          }
        } else if (completedPhenomenon['length'] === 12) {
          if (completedPhenomenon['position_over_2040'] === 1) {
            completedPhenomenon['leftPostion1st'] = '57%'
          } else if (completedPhenomenon['position_over_2040'] === 2) {
            completedPhenomenon['leftPostion1st'] = '47%'
          } else if (completedPhenomenon['position_over_2040'] === 3) {
            completedPhenomenon['leftPostion1st'] = '37%'
          } else if (completedPhenomenon['position_over_2040'] === 4) {
            completedPhenomenon['leftPostion1st'] = '67%'
          } else if (completedPhenomenon['position_over_2040'] === 5) {
            completedPhenomenon['leftPostion1st'] = '27%'
          } else if (completedPhenomenon['position_over_2040'] === 6) {
            completedPhenomenon['leftPostion1st'] = '77%'
          } else if (completedPhenomenon['position_over_2040'] === 7) {
            completedPhenomenon['leftPostion1st'] = '17%'
          } else if (completedPhenomenon['position_over_2040'] === 8) {
            completedPhenomenon['leftPostion1st'] = '87%'
          } else if (completedPhenomenon['position_over_2040'] === 9) {
            completedPhenomenon['leftPostion1st'] = '7.7%'
          } else if (completedPhenomenon['position_over_2040'] === 10) {
            completedPhenomenon['leftPostion1st'] = '92.7%'
          } else if (completedPhenomenon['position_over_2040'] === 11) {
            completedPhenomenon['leftPostion1st'] = '4.8%'
          } else if (completedPhenomenon['position_over_2040'] === 12) {
            completedPhenomenon['leftPostion1st'] = '96.9%'
          }
        }
      } else if (!!completedPhenomenon?.length) {
        if (
          completedPhenomenon?.length > 0 &&
          completedPhenomenon?.length > 11
        ) {
          // has 2-4 -6 same years ( even numbers)
          if (completedPhenomenon?.length % 2 == 0) {
            if (completedPhenomenon?.position === 0) {
              completedPhenomenon['leftPostion1st'] = '41.7%'
            } else if (completedPhenomenon?.position === 1) {
              completedPhenomenon['leftPostion1st'] = '58.3%'
            } else if (completedPhenomenon?.position === 2) {
              completedPhenomenon['leftPostion1st'] = '33.4%'
            } else if (completedPhenomenon?.position === 3) {
              completedPhenomenon['leftPostion1st'] = '66.6%'
            } else if (completedPhenomenon?.position === 4) {
              completedPhenomenon['leftPostion1st'] = '25.1%'
            } else if (completedPhenomenon?.position === 5) {
              completedPhenomenon['leftPostion1st'] = '74.9%'
            } else if (completedPhenomenon?.position === 6) {
              completedPhenomenon['leftPostion1st'] = '16.8%'
            } else if (completedPhenomenon?.position === 7) {
              completedPhenomenon['leftPostion1st'] = '83.2%'
            } else if (completedPhenomenon?.position === 8) {
              completedPhenomenon['leftPostion1st'] = '8.5%'
            } else if (completedPhenomenon?.position === 9) {
              completedPhenomenon['leftPostion1st'] = '91.5%'
            } else if (completedPhenomenon?.position === 10) {
              completedPhenomenon['leftPostion1st'] = '2.4%'
            } else if (completedPhenomenon?.position === 11) {
              completedPhenomenon['leftPostion1st'] = '97.7%'
            }
          } else {
            if (completedPhenomenon?.position === 0) {
              const min = 45
              const max = 55
              const randomNumber = Math.random() * (max - min + 1) + min
              completedPhenomenon['leftPostion1st'] = randomNumber + '%'
              //  completedPhenomenon['leftPostion1st'] = '50%'
            } else if (completedPhenomenon?.position === 1) {
              completedPhenomenon['leftPostion1st'] = '41.7%'
            } else if (completedPhenomenon?.position === 2) {
              completedPhenomenon['leftPostion1st'] = '58.3%'
            } else if (completedPhenomenon?.position === 3) {
              completedPhenomenon['leftPostion1st'] = '33.4%'
            } else if (completedPhenomenon?.position === 4) {
              completedPhenomenon['leftPostion1st'] = '66.6%'
            } else if (completedPhenomenon?.position === 5) {
              completedPhenomenon['leftPostion1st'] = '25.1%'
            } else if (completedPhenomenon?.position === 6) {
              completedPhenomenon['leftPostion1st'] = '74.9%'
            } else if (completedPhenomenon?.position === 7) {
              completedPhenomenon['leftPostion1st'] = '16.8%'
            } else if (completedPhenomenon?.position === 8) {
              completedPhenomenon['leftPostion1st'] = '83.2%'
            } else if (completedPhenomenon?.position === 9) {
              completedPhenomenon['leftPostion1st'] = '8.5%'
            } else if (completedPhenomenon?.position === 10) {
              completedPhenomenon['leftPostion1st'] = '91.5%'
            } else if (completedPhenomenon?.position === 11) {
              completedPhenomenon['leftPostion1st'] = '2.8%'
            }
          }
        } else if (
          completedPhenomenon?.length > 0 &&
          completedPhenomenon?.length > 9 // 10 or 11
        ) {
          if (completedPhenomenon?.length % 2 == 0) {
            if (completedPhenomenon?.position === 0) {
              completedPhenomenon['leftPostion1st'] = '45%'
            } else if (completedPhenomenon?.position === 1) {
              completedPhenomenon['leftPostion1st'] = '55%'
            } else if (completedPhenomenon?.position === 2) {
              completedPhenomenon['leftPostion1st'] = '35%'
            } else if (completedPhenomenon?.position === 3) {
              completedPhenomenon['leftPostion1st'] = '65%'
            } else if (completedPhenomenon?.position === 4) {
              completedPhenomenon['leftPostion1st'] = '25%'
            } else if (completedPhenomenon?.position === 5) {
              completedPhenomenon['leftPostion1st'] = '75%'
            } else if (completedPhenomenon?.position === 6) {
              completedPhenomenon['leftPostion1st'] = '15%'
            } else if (completedPhenomenon?.position === 7) {
              completedPhenomenon['leftPostion1st'] = '85%'
            } else if (completedPhenomenon?.position === 8) {
              completedPhenomenon['leftPostion1st'] = '5%'
            } else if (completedPhenomenon?.position === 9) {
              completedPhenomenon['leftPostion1st'] = '95%'
            }
          } else {
            if (completedPhenomenon?.position === 0) {
              const min = 45
              const max = 55
              const randomNumber = Math.random() * (max - min + 1) + min
              completedPhenomenon['leftPostion1st'] = randomNumber + '%'
              //  completedPhenomenon['leftPostion1st'] = '50%'
            } else if (completedPhenomenon?.position === 1) {
              const min = 38
              const max = 42
              const randomNumber = Math.random() * (max - min + 1) + min
              completedPhenomenon['leftPostion1st'] = randomNumber + '%'
              //  completedPhenomenon['leftPostion1st'] = '40%'
            } else if (completedPhenomenon?.position === 2) {
              const min = 55
              const max = 65
              const randomNumber = Math.random() * (max - min + 1) + min
              completedPhenomenon['leftPostion1st'] = randomNumber + '%'
              //  completedPhenomenon['leftPostion1st'] = '60%'
            } else if (completedPhenomenon?.position === 3) {
              const min = 25
              const max = 35
              const randomNumber = Math.random() * (max - min + 1) + min
              completedPhenomenon['leftPostion1st'] = randomNumber + '%'
              //  completedPhenomenon['leftPostion1st'] = '30%'
            } else if (completedPhenomenon?.position === 4) {
              const min = 65
              const max = 75
              const randomNumber = Math.random() * (max - min + 1) + min
              completedPhenomenon['leftPostion1st'] = randomNumber + '%'
              //  completedPhenomenon['leftPostion1st'] = '70%'
            } else if (completedPhenomenon?.position === 5) {
              const min = 15
              const max = 25
              const randomNumber = Math.random() * (max - min + 1) + min
              completedPhenomenon['leftPostion1st'] = randomNumber + '%'
              //  completedPhenomenon['leftPostion1st'] = '20%'
            } else if (completedPhenomenon?.position === 6) {
              const min = 75
              const max = 85
              const randomNumber = Math.random() * (max - min + 1) + min
              completedPhenomenon['leftPostion1st'] = randomNumber + '%'
              //  completedPhenomenon['leftPostion1st'] = '80%'
            } else if (completedPhenomenon?.position === 7) {
              const min = 5
              const max = 15
              const randomNumber = Math.random() * (max - min + 1) + min
              completedPhenomenon['leftPostion1st'] = randomNumber + '%'
              //  completedPhenomenon['leftPostion1st'] = '10%'
            } else if (completedPhenomenon?.position === 8) {
              const min = 85
              const max = 95
              const randomNumber = Math.random() * (max - min + 1) + min
              completedPhenomenon['leftPostion1st'] = randomNumber + '%'
              //  completedPhenomenon['leftPostion1st'] = '90%'
            } else if (completedPhenomenon?.position === 9) {
              const min = 90
              const max = 100
              const randomNumber = Math.random() * (max - min + 1) + min
              completedPhenomenon['leftPostion1st'] = randomNumber + '%'
              //  completedPhenomenon['leftPostion1st'] = '99%'
            } else if (completedPhenomenon?.position === 10) {
              const min = 1
              const max = 5
              const randomNumber = Math.random() * (max - min + 1) + min
              completedPhenomenon['leftPostion1st'] = randomNumber + '%'
              //  completedPhenomenon['leftPostion1st'] = '3%'
            }
          }
        } else if (
          completedPhenomenon?.length > 0 &&
          completedPhenomenon?.length > 7 // 8 or 9
        ) {
          if (completedPhenomenon?.length % 2 === 0) {
            if (completedPhenomenon?.position === 0) {
              const min = 55
              const max = 65
              const randomNumber = Math.random() * (max - min + 1) + min
              completedPhenomenon['leftPostion1st'] = randomNumber + '%'
              completedPhenomenon['leftPostion1st'] = '60%'
            } else if (completedPhenomenon?.position === 1) {
              const min = 35
              const max = 45
              const randomNumber = Math.random() * (max - min + 1) + min
              completedPhenomenon['leftPostion1st'] = randomNumber + '%'
              //  completedPhenomenon['leftPostion1st'] = '40%'
            } else if (completedPhenomenon?.position === 2) {
              const min = 65
              const max = 75
              const randomNumber = Math.random() * (max - min + 1) + min
              completedPhenomenon['leftPostion1st'] = randomNumber + '%'
              //  completedPhenomenon['leftPostion1st'] = '73%'
            } else if (completedPhenomenon?.position === 3) {
              const min = 20
              const max = 33
              const randomNumber = Math.random() * (max - min + 1) + min
              completedPhenomenon['leftPostion1st'] = randomNumber + '%'
              //  completedPhenomenon['leftPostion1st'] = '27%'
            } else if (completedPhenomenon?.position === 4) {
              const min = 80
              const max = 93
              const randomNumber = Math.random() * (max - min + 1) + min
              completedPhenomenon['leftPostion1st'] = randomNumber + '%'
              //  completedPhenomenon['leftPostion1st'] = '86%'
            } else if (completedPhenomenon?.position === 5) {
              const min = 15
              const max = 20
              const randomNumber = Math.random() * (max - min + 1) + min
              completedPhenomenon['leftPostion1st'] = randomNumber + '%'
              //  completedPhenomenon['leftPostion1st'] = '14%'
            } else if (completedPhenomenon?.position === 6) {
              const min = 90
              const max = 100
              const randomNumber = Math.random() * (max - min + 1) + min
              completedPhenomenon['leftPostion1st'] = randomNumber + '%'
              //  completedPhenomenon['leftPostion1st'] = '98%'
            } else if (completedPhenomenon?.position === 7) {
              const min = 1
              const max = 5
              const randomNumber = Math.random() * (max - min + 1) + min
              completedPhenomenon['leftPostion1st'] = randomNumber + '%'
              //  completedPhenomenon['leftPostion1st'] = '2%'
            }
          } else {
            // 9
            if (completedPhenomenon?.position === 0) {
              const min = 45
              const max = 55
              const randomNumber = Math.random() * (max - min + 1) + min
              completedPhenomenon['leftPostion1st'] = randomNumber + '%'
              //  completedPhenomenon['leftPostion1st'] = '50%'
            }
            if (completedPhenomenon?.position === 1) {
              completedPhenomenon['leftPostion1st'] = '64.5%'
            } else if (completedPhenomenon?.position === 2) {
              completedPhenomenon['leftPostion1st'] = '34.5%'
            } else if (completedPhenomenon?.position === 3) {
              completedPhenomenon['leftPostion1st'] = '74.4%'
            } else if (completedPhenomenon?.position === 4) {
              completedPhenomenon['leftPostion1st'] = '24.4%'
            } else if (completedPhenomenon?.position === 5) {
              completedPhenomenon['leftPostion1st'] = '84.5%'
            } else if (completedPhenomenon?.position === 6) {
              completedPhenomenon['leftPostion1st'] = '14.5%'
            } else if (completedPhenomenon?.position === 7) {
              completedPhenomenon['leftPostion1st'] = '94.4%'
            } else if (completedPhenomenon?.position === 8) {
              completedPhenomenon['leftPostion1st'] = '2.4%'
            }
          }
        } else if (
          completedPhenomenon?.length > 0 &&
          completedPhenomenon?.length > 5 // 6 or 7
        ) {
          if (completedPhenomenon?.length % 2 === 0) {
            if (completedPhenomenon?.position === 0) {
              completedPhenomenon['leftPostion1st'] = '42.7%'
            } else if (completedPhenomenon?.position === 1) {
              completedPhenomenon['leftPostion1st'] = '58.6%'
            } else if (completedPhenomenon?.position === 2) {
              completedPhenomenon['leftPostion1st'] = '28.8%'
            } else if (completedPhenomenon?.position === 3) {
              completedPhenomenon['leftPostion1st'] = '70.7%'
            } else if (completedPhenomenon?.position === 4) {
              completedPhenomenon['leftPostion1st'] = '11.3%'
            } else if (completedPhenomenon?.position === 5) {
              completedPhenomenon['leftPostion1st'] = '93.8%'
            }
          } else {
            // 7
            if (completedPhenomenon?.position === 0) {
              const min = 45
              const max = 55
              const randomNumber = Math.random() * (max - min + 1) + min
              completedPhenomenon['leftPostion1st'] = randomNumber + '%'
              //  completedPhenomenon['leftPostion1st'] = '50%'
            }
            if (completedPhenomenon?.position === 1) {
              completedPhenomenon['leftPostion1st'] = '33.4%'
            } else if (completedPhenomenon?.position === 2) {
              completedPhenomenon['leftPostion1st'] = '68.7%'
            } else if (completedPhenomenon?.position === 3) {
              completedPhenomenon['leftPostion1st'] = '16.8%'
            } else if (completedPhenomenon?.position === 4) {
              completedPhenomenon['leftPostion1st'] = '83.2%'
            } else if (completedPhenomenon?.position === 5) {
              completedPhenomenon['leftPostion1st'] = '4.7%'
            } else if (completedPhenomenon?.position === 6) {
              completedPhenomenon['leftPostion1st'] = '93.8%'
            }
          }
        } else if (
          completedPhenomenon?.length > 0 &&
          completedPhenomenon?.length > 3 // 4 or 5
        ) {
          if (completedPhenomenon?.length % 2 === 0) {
            if (completedPhenomenon?.position === 0) {
              completedPhenomenon['leftPostion1st'] = '38.7%'
            } else if (completedPhenomenon?.position === 1) {
              completedPhenomenon['leftPostion1st'] = '69%'
            } else if (completedPhenomenon?.position === 2) {
              completedPhenomenon['leftPostion1st'] = '23%'
            } else if (completedPhenomenon?.position === 3) {
              completedPhenomenon['leftPostion1st'] = '80.9%'
            } else if (completedPhenomenon?.position === 4) {
              completedPhenomenon['leftPostion1st'] = '1.3%'
            } else if (completedPhenomenon?.position === 5) {
              completedPhenomenon['leftPostion1st'] = '88%'
            }
          } else {
            // 9
            if (completedPhenomenon?.position === 0) {
              const min = 45
              const max = 55
              const randomNumber = Math.random() * (max - min + 1) + min
              completedPhenomenon['leftPostion1st'] = randomNumber + '%'
              //  completedPhenomenon['leftPostion1st'] = '50%'
            }
            if (completedPhenomenon?.position === 1) {
              completedPhenomenon['leftPostion1st'] = '28%'
            } else if (completedPhenomenon?.position === 2) {
              completedPhenomenon['leftPostion1st'] = '75.5%'
            } else if (completedPhenomenon?.position === 3) {
              completedPhenomenon['leftPostion1st'] = '5.7%'
            } else if (completedPhenomenon?.position === 4) {
              completedPhenomenon['leftPostion1st'] = '95.3%'
            }
          }
        } else if (
          completedPhenomenon?.length > 0 &&
          completedPhenomenon?.length > 1 // 2 or 3
        ) {
          if (completedPhenomenon?.length % 2 === 0) {
            if (completedPhenomenon?.position === 0) {
              completedPhenomenon['leftPostion1st'] = '35.8%'
            } else if (completedPhenomenon?.position === 1) {
              completedPhenomenon['leftPostion1st'] = '56.3%'
            } else if (completedPhenomenon?.position === 2) {
              completedPhenomenon['leftPostion1st'] = '5.3%'
            } else if (completedPhenomenon?.position === 3) {
              completedPhenomenon['leftPostion1st'] = '93.3%'
            }
          } else {
            // 3
            if (completedPhenomenon?.position === 0) {
              const min = 45
              const max = 55
              const randomNumber = Math.random() * (max - min + 1) + min
              completedPhenomenon['leftPostion1st'] = randomNumber + '%'
              //  completedPhenomenon['leftPostion1st'] = '50%'
            }
            if (completedPhenomenon?.position === 1) {
              completedPhenomenon['leftPostion1st'] = '27.7%'
            } else if (completedPhenomenon?.position === 2) {
              completedPhenomenon['leftPostion1st'] = '68.7%'
            } else if (completedPhenomenon?.position === 3) {
              completedPhenomenon['leftPostion1st'] = '7.3%'
            } else if (completedPhenomenon?.position === 4) {
              completedPhenomenon['leftPostion1st'] = '88%'
            }
          }
        }
      }
    } else {
      const min = 5
      const max = 95
      const randomNumber = Math.random() * (max - min + 1) + min
      completedPhenomenon['leftPostion1st'] = randomNumber + '%'
    }

    const howmuchBetweenYears = 2025 - thisYear
    const howmuchBetweenYearsOfPhen = 2025 - mediumTimeRange
    const range = (howmuchBetweenYearsOfPhen / 100) * howmuchBetweenYears
    const plusHowManyPxFromTheLowestPx = (62.5 * range) / 0.5

    if (mediumTimeRange <= 2025 && mediumTimeRange >= thisYear) {
      fontSizePhen =
        (fontSizePhen * fontSizePhen) / fontSizePhen + extraFontSize
      fontSizePhenIcon =
        (thisYear / mediumTimeRange - (1 - thisYear / mediumTimeRange) * 50) *
        fontSizePhenIcon2
      const howmuchBetweenYears = 2025 - thisYear // 2
      const howmuchBetweenYearsOfPhen = 2025 - mediumTimeRange // 2
      const range =
        ((howmuchBetweenYears - howmuchBetweenYearsOfPhen) * 100) /
        howmuchBetweenYears

      // thisYear -> 30px
      // 2025 ->
      // 2040 -> 16px

      top = 390 - (range / 100) * 126

      // 2025 -> 100
      // thisYear -> 0
      // 2024 ->
      // 2 nam -> 100
      // 1     ->  range ?

      // 127 px -> 100 %
      // ?   -> 50%

      // 280 px -> 100 %
      // 127 px -> 50 %
      // 407px -> 0%
      // 62.5 px -> 50 %
      //         -> 50 %
    } else if (mediumTimeRange <= 2030 && mediumTimeRange >= 2025) {
      fontSizePhen =
        (fontSizePhen * (fontSizePhen - 1 * 1)) / fontSizePhen + extraFontSize
      fontSizePhenIcon =
        (thisYear / mediumTimeRange - (1 - thisYear / mediumTimeRange) * 50) *
        fontSizePhenIcon2
      const howmuchBetweenYears = 2030 - 2025
      const howmuchBetweenYearsOfPhen = 2030 - mediumTimeRange

      const range =
        ((howmuchBetweenYears - howmuchBetweenYearsOfPhen) * 100) /
        howmuchBetweenYears

      top = 264 - (range / 100) * 104
      // 173 px -> 100 %
      // 280 px -> 0 %
      // 274 px -> 50 %
      // 107 px -> 100 % length
      //         -> 50 %
    } else if (mediumTimeRange <= 2035 && mediumTimeRange >= 2030) {
      fontSizePhen =
        (fontSizePhen * (fontSizePhen - 1 * 2)) / fontSizePhen + extraFontSize
      fontSizePhenIcon =
        (thisYear / mediumTimeRange - (1 - thisYear / mediumTimeRange) * 50) *
        fontSizePhenIcon2
      const howmuchBetweenYears = 2035 - 2030
      const howmuchBetweenYearsOfPhen = 2035 - mediumTimeRange

      const range =
        ((howmuchBetweenYears - howmuchBetweenYearsOfPhen) * 100) /
        howmuchBetweenYears

      top = 160 - (range / 100) * 82
      // 173 px -> 0 %
      // 187 px -> 50 %
      // 88px -> 100%
      // 36 px -> 50 %
      //         -> 50 %
    } else if (mediumTimeRange <= 2040 && mediumTimeRange >= 2035) {
      fontSizePhen =
        (fontSizePhen * (fontSizePhen - 1 * 3)) / fontSizePhen + extraFontSize
      fontSizePhenIcon =
        (thisYear / mediumTimeRange - (1 - thisYear / mediumTimeRange) * 50) *
        fontSizePhenIcon2
      const howmuchBetweenYears = 2040 - 2035
      const howmuchBetweenYearsOfPhen = 2040 - mediumTimeRange
      const range =
        ((howmuchBetweenYears - howmuchBetweenYearsOfPhen) * 100) /
        howmuchBetweenYears

      top = 78 - (range / 100) * 63
      // 88 px -> 0 %
      // 125.5 px -> 50 %
      // 22px -> 100%
      // 25.5 px -> 50 %
      //         -> 50 %
    } else if (mediumTimeRange > 2040) {
      fontSizePhen =
        (fontSizePhen * (fontSizePhen - 1 * 4)) / fontSizePhen + extraFontSize
      fontSizePhenIcon =
        (thisYear / 2041 - (1 - thisYear / 2041) * 50) * fontSizePhenIcon2
      // const howmuchBetweenYears = 2050 - 2040
      // const howmuchBetweenYearsOfPhen = 2050 - mediumTimeRange
      // const range =
      //   ((howmuchBetweenYears - howmuchBetweenYearsOfPhen) * 100) /
      //   howmuchBetweenYears
      const min = -50
      const max = 5
      const randomNumber = Math.random() * (max - min) + min
      top = randomNumber
      // 65 px -> 0 %
      // 125.5 px -> 50 %
      // 100px -> 100%
      // 17.5 px -> 50 %
      //         -> 50 %
    } else if (mediumTimeRange < thisYear) {
      fontSizePhen =
        (fontSizePhen * fontSizePhen) / fontSizePhen + extraFontSize
      fontSizePhenIcon =
        (thisYear / mediumTimeRange - (1 - thisYear / mediumTimeRange) * 50) *
        fontSizePhenIcon2
      // const howmuchBetweenYears = 2025 - thisYear // 2
      // const howmuchBetweenYearsOfPhen = 2025 - mediumTimeRange // 2
      // const range =
      //   ((howmuchBetweenYears - howmuchBetweenYearsOfPhen) * 100) /
      //   howmuchBetweenYears

      // thisYear -> 30px
      // 2025 ->
      // 2040 -> 16px

      top = 410
      // 65 px -> 0 %
      // 125.5 px -> 50 %
      // 100px -> 100%
      // 17.5 px -> 50 %
      //         -> 50 %
    }
    completedPhenomenon['fontSizePhenIcon'] = fontSizePhenIcon

    completedPhenomenon['topPostion1st'] = top
  })
  return collection
}
export const isColliding = function (el1, el2) {
  var rect1 = el1.getBoundingClientRect()
  var rect2 = el2.getBoundingClientRect()

  return !(
    rect1.top > rect2.bottom ||
    rect1.right < rect2.left ||
    rect1.bottom < rect2.top ||
    rect1.left > rect2.right
  )
}
export const isInside = function (el1, el2) {
  var rect1 = el1.getBoundingClientRect()
  var rect2 = el2.getBoundingClientRect()

  return (
    rect2.top <= rect1.top &&
    rect1.top <= rect2.bottom &&
    rect2.top <= rect1.bottom &&
    rect1.bottom <= rect2.bottom &&
    rect2.left <= rect1.left &&
    rect1.left <= rect2.right &&
    rect2.left <= rect1.right &&
    rect1.right <= rect2.right
  )
}
